// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const RestApiPage = lazy(() => import('./pages/RestApiPage'));
const GraphqlApiPage = lazy(() => import('./pages/GraphqlApiPage'));
const WebhooksConsolePage = lazy(() => import('./pages/WebhooksConsolePage'));
const CustomExtensionsPage = lazy(() => import('./pages/CustomExtensionsPage'));
const AutomationConnectorsPage = lazy(() => import('./pages/AutomationConnectorsPage'));
const ApiMonitoringPage = lazy(() => import('./pages/ApiMonitoringPage'));
const ApiKeysPage = lazy(() => import('./pages/ApiKeysPage'));
const OauthAppsPage = lazy(() => import('./pages/OauthAppsPage'));

export const ApiRoutes: RouteObject = {
  path: 'api',
  element: <ModuleGuard moduleId="core.api" />,
  children: [
    { path: 'rest-api', element: <RestApiPage />, handle: { crumb: 'REST API' } },
    { path: 'graphql-api', element: <GraphqlApiPage />, handle: { crumb: 'GraphQL API' } },
    { path: 'webhooks-console', element: <WebhooksConsolePage />, handle: { crumb: 'Webhooks Console' } },
    { path: 'custom-extensions', element: <CustomExtensionsPage />, handle: { crumb: 'Custom Extensions' } },
    { path: 'automation-connectors', element: <AutomationConnectorsPage />, handle: { crumb: 'Automation Connectors' } },
    { path: 'api-monitoring', element: <ApiMonitoringPage />, handle: { crumb: 'Api Monitoring' } },
    { path: 'api-keys', element: <ApiKeysPage />, handle: { crumb: 'API Keys' } },
    { path: 'oauth-apps', element: <OauthAppsPage />, handle: { crumb: 'OAuth Apps' } },
  ],
};
